export var Country;
(function (Country) {
    Country["Norge"] = "Norge";
    Country["Polska"] = "Polska";
})(Country || (Country = {}));
export const getCountry = () => {
    var _a;
    const country = (_a = (new URL(window.location.href)).searchParams.get('country')) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    switch (true) {
        case country === Country.Norge.toLowerCase():
            return Country.Norge;
        case country === Country.Polska.toLowerCase():
            return Country.Polska;
        default:
            return Country.Norge;
    }
};
export const isValidCountry = (country) => {
    return !country || Object.values(Country).some(c => c.toLowerCase() === country);
};
